import React, { useState } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import '../../assets/dsgov/css/components/checkbox.css';

const Checkbox = (_props) => {
  const props = parseProps(_props);

  const [componentId] = useState(`checkbox${componentIdGenerator()}`);
  const [checked, setChecked] = useState(props.checked ? props.checked : false);

  let classes = `br-checkbox ${componentId} `;
  if (props.classes) classes += props.classes;
  if (props.small) classes += 'is-small';

  const attr = {
    invalid: props.invalid,
    valid: props.valid,
    title: props.title,
  };

  const attrCheck = {
    disabled: props.disabled,

  };

  const attrLabel = {
    disabled: props.disabled,
  };

  const id = props.id ? props.id : componentId;

  const onChange = () => {
    setChecked(!checked);
    if (props.onClick) props.onClick();
  };

  return (
    <div className={classes} {...attr} name="check">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...attrCheck}
      />
      <label
        htmlFor={id}
        {...attrLabel}
      >
        {props.label}
      </label>
    </div>
  );
};

export default Checkbox;
